<!--
# 边框、背景颜色、字体颜色、hover可自行设置
# 类型type为default，需要自定义样式
# 设置is-blank为true是，需要同时设置type

# 已实现的按钮type：
  primary：蓝色背景，白色字体，无边框，hover为浅蓝色
  primary + is-blank：白色背景，蓝色字体，蓝色边框，hover为浅蓝色
-->

<template>
  <div
    class="bg-btn"
    :class="{primary: type === 'primary' && !isBlank, 'primary-blank': isBlank && type === 'primary'}"
    :style="{width: `${width}px`, height: `${height}px`, 'line-height': `${height}px`,'font-weight': fontWeight, 'font-size': `${fontSize}px`}">
    <span class="prefix"></span>
    <span><slot></slot></span>
    <span class="suffix"></span>
  </div>
</template>

<script>
  export default {
    name: 'bg-button',
    props: {
      type: {
        type: String,
        default: 'default',
      },
      isBlank: Boolean,
      disabled: Boolean,
      width: {
        type: String | Number,
        default: 120,
      },
      height: {
        type: String | Number,
        default: 44,
      },
      fontWeight: {
        type: String,
        default: 'normal',
      },
      fontSize: {
        type: Number | String,
        default: 20
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../static/css/common';

  .bg-btn{
    display: inline-block;
    text-align: center;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
  }

  /**
   * 按钮默认样式
   */
  .primary{
    color: #fff;
    background: $bg-blue;

    &:hover{
      background: $color-start;
    }
  }
  .primary-blank{
    color: $bg-blue;
    background: #fff;
    border: 1px solid $bg-blue;

    &:hover{
      color: $color-start;
      border-color: $color-start;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BgButton/BgButton.vue